import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';
import { useScreenResolution } from '@app/hooks';
import { selectHasFiber } from '@app/redux';
import { selectUserInfo } from '@app/redux/userInfo';

import { AccountType } from '@mfe/shared/schema-types';

import FiberContent from '../FiberContent';
import ResidentialContent from '../ResidentialContent';
import SMBContent from '../SmbContent';

import styles from './styles.module.scss';

type TermsAndConditionsModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const TermsAndConditionsModal = ({ isOpen, handleClose }: TermsAndConditionsModalProps) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.terms.modal',
  });

  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);
  const isSMB = accountType === AccountType.Smb;
  const isFiber = useSelector(selectHasFiber);

  const Content = isSMB ? SMBContent : isFiber ? FiberContent : ResidentialContent;

  return (
    <TermsAndConditionsModalWrapper isOpen={isOpen} handleClose={handleClose} header={t('title')}>
      <Content />
    </TermsAndConditionsModalWrapper>
  );
};

type WrapperProps = TermsAndConditionsModalProps & {
  header: string;
  children: React.ReactNode;
};

const TermsAndConditionsModalWrapper = ({ isOpen, handleClose, header, children }: WrapperProps) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.terms.modal',
  });

  const { isMedium, isLarge, isExtraLarge } = useScreenResolution();
  const isDesktop = isMedium || isLarge || isExtraLarge;

  return (
    <CustomStandardModal
      isOpen={isOpen}
      onClose={handleClose}
      header={header}
      actions={{ primary: { label: t('button'), onClick: handleClose } }}
      size={isDesktop ? 'medium' : 'xLarge'}
    >
      <div className={styles['modalContent']}>{children}</div>
    </CustomStandardModal>
  );
};

export default TermsAndConditionsModal;
